import {Channels} from 'cl-api';
import {AmazonAccountType, EbayAccountType} from '../../../App/initialStore';
import * as routes from '../../../App/routeConstants';
import {AmazonListing} from 'cl-api';
import {STATUS_FILTER_ACTIVE} from '../../../MyAccount/Listings/consts';

export function getListingsPageHref(account: EbayAccountType & AmazonAccountType) {
  switch (account.channel) {
    case Channels.EBay:
      return `${routes.MyAccount.Listings}?selectedSellerId=${account.UserID}&statusFilter=${STATUS_FILTER_ACTIVE}`;
    case Channels.Amazon:
      return `${routes.MyAccount.AmazonListings}?selectedSellerId=${account.amazonSellerId}&statusFilter=${
        AmazonListing.AmazonStatusFilterEnum.Active
      }`;
    default:
      break;
  }
}
